import { Lightning, Trophy, UsersThree } from "@phosphor-icons/react";

// Quick starts: shown as chips under the greeting in the empty chat, and again
// on the ended-conversation screen. `message` is what gets sent when tapped.
export const STARTER_PILLS = [
  { label: "Book instantly", Icon: Lightning, message: "I'd like to book a court" },
  { label: "Open play", Icon: UsersThree, message: "I'm looking for open play near me" },
  { label: "Tournaments", Icon: Trophy, message: "I'm looking for tournaments near me" },
];
